module.exports = __webpack_public_path__ + "static/img/delete.ad39ee48.png";